(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableFormTabs =  function (){
      $('.b-form_tabs').gnv_formTabs();
  };

  $.gnv.formTabs = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$el.data("gnv.formTabs", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.floatingLabel.defaultOptions, options);

      base.$el.find('[data-formTabs-ref]').on('click', function(e) {
        e.preventDefault();
        var name = $(this).data('formtabs-ref');

        $('.b-form_tabs__referrer').hide();
        $(name).show();

        base.$el.find('[data-formTabs-ref]').removeClass('selected');
        $(this).addClass('selected');
      });
    };
    base.init();
  };

  $.gnv.formTabs.defaultOptions = {};

  $.fn.gnv_formTabs = function(options){
    return this.each(function(){
      (new $.gnv.formTabs(this, options));
    });
  };

  $.gnv.enableFormTabs();

})(jQuery);




